import classNames from 'classnames';
import { observer } from 'mobx-react';

import styles from './TelLink.module.scss';

import { Icon, IconType } from '@components/Icon';
import { Tooltip } from '@components/Tooltip';
import { formatPhoneNumber } from '@utils/formatPhoneNumber';
import { removeNotNumbers } from '@utils/removeNotNumbers';
import { useCopyToClipboard } from '@utils/hooks/useCopyToClipboard';
import { store } from '@store';
import Copy from './copy.svg';

interface Props {
    tel: string;
    withIcon?: boolean;
    withCopy?: boolean;
    theme?: TelLinkTheme;
}

export enum TelLinkTheme {
    // @ts-ignore
    InheritColor = styles.rootInheritColor,
}

export const TelLink = observer(({ tel, withIcon, withCopy, theme }: Props) => {
    const { copyTitle, onCopyClick } = useCopyToClipboard(tel);
    const canMakeCall = store.authUser.hasShortNumber;

    const handlePhoneClick = () => {
        const { phoneWidget } = store.app;

        phoneWidget.initialPhoneNumber = removeNotNumbers(tel);
        phoneWidget.isOpen = true;
    };

    return (
        <div className={classNames([styles.root, theme])}>
            {canMakeCall ? (
                <div
                    className={styles.tel}
                    onClick={handlePhoneClick}
                >
                    {withIcon && <Icon type={IconType.PHONE} />}
                    {formatPhoneNumber(tel) ?? tel}
                </div>
            ) : (
                <a
                    className={styles.tel}
                    href={`tel:${tel}`}
                >
                    {withIcon && <Icon type={IconType.PHONE} />}
                    {formatPhoneNumber(tel) ?? tel}
                </a>
            )}
            {withCopy && (
                <>
                    <div className={styles.spacer} />
                    <Tooltip title={copyTitle}>
                        <button
                            type="button"
                            className={styles.copyButton}
                            onClick={onCopyClick}
                        >
                            <Copy />
                        </button>
                    </Tooltip>
                </>
            )}
        </div>
    );
});
